import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

type OnSend = () => void | Promise<unknown>;

type EnterToSendEvent = {
  key: string;
  shiftKey: boolean;
  nativeEvent: {
    isComposing?: boolean;
  };
  preventDefault: () => void;
};

export function shouldSendOnEnter(
  event: Pick<EnterToSendEvent, "key" | "shiftKey" | "nativeEvent">,
) {
  return (
    event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing
  );
}

export function useEnterToSend(onSend: OnSend) {
  const isMobile = useIsMobile();

  return React.useCallback(
    (event: React.KeyboardEvent) => {
      if (isMobile || !shouldSendOnEnter(event)) {
        return;
      }
      event.preventDefault();
      void onSend();
    },
    [isMobile, onSend],
  );
}
